import moment from "moment";
import type { FormikValues } from "formik";
import { LocalizationProvider } from '@mui/x-date-pickers-v.6/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers-v.6/AdapterMoment';
import { DateTimePicker } from '@mui/x-date-pickers-v.6/DateTimePicker';
import { DateTimeFormatRepository } from "consts/general";
import { getFormInputProps } from "util/forms";
import { when } from "util/support";
import { useForm } from "hooks";
import { FormField } from "./types";

const DomainExpiresAtDate = <T extends FormikValues>({
    values,
    handleBlur,
    setFieldValue,
    setFieldTouched,
    ...form
}: ReturnType<typeof useForm<T>>) => (
    <LocalizationProvider dateAdapter={AdapterMoment}>
        <DateTimePicker
            slotProps={{
                textField: {
                    ...getFormInputProps(FormField.ExpiresAtDate, form),
                    name: FormField.ExpiresAtDate,
                    size: 'small',
                    fullWidth: true,
                    onBlur: handleBlur
                }
            }}
            views={['year', 'month', 'day']}
            label='Expiry Date'
            value={when(
                values[FormField.ExpiresAtDate],
                moment(values[FormField.ExpiresAtDate]),
                null
            )}
            format={DateTimeFormatRepository.Default}
            onChange={value => {
                setFieldValue(FormField.ExpiresAtDate, value);
                setTimeout(() => setFieldTouched(FormField.ExpiresAtDate, true, true));
            }}
        />
    </LocalizationProvider>
);

export default DomainExpiresAtDate;
